// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__4Swr1","sendOtp":"AuthorizeToLogin_sendOtp__14c3x"};